import {ApolloLink, Observable} from 'apollo-link'

import {readBearerToken} from './token'

/**
 * Apollo v1 link that authorizes every operation the VN way: an explicit `Authorization: Bearer`
 * header (the token must reach whatever rotating domain is live now — a cookie set on a previous
 * domain would not) and `credentials: 'omit'` so no origin-bound cookie is ever attached. The token
 * read is async (IndexedDB), so we wrap forwarding in an Observable that resolves it first.
 *
 * `readToken` is injected for tests; production reads the shared IndexedDB store.
 */
export const createVnAuthLink = (
  readToken: () => Promise<string | null> = readBearerToken,
): ApolloLink =>
  new ApolloLink(
    (operation, forward) =>
      new Observable((observer) => {
        let sub: {unsubscribe: () => void} | undefined
        readToken().then((token) => {
          operation.setContext((prev: {headers?: Record<string, string>}) => ({
            ...prev,
            credentials: 'omit',
            headers: token ? {...(prev.headers ?? {}), Authorization: `Bearer ${token}`} : prev.headers ?? {},
          }))
          sub = forward(operation).subscribe(observer)
        })
        return (): void => sub?.unsubscribe()
      }),
  )
